import React from "react"
import { Link } from "react-router-dom"
import * as moment from "moment"
import { Badge } from "reactstrap"

const formateDate = (date, format) => {
  const dateFormat = format ? format : "DD MMM Y"
  const date1 = moment(new Date(date)).format(dateFormat)
  return date1
}
const toLowerCase1 = str => {
  return str === "" || str === undefined ? "" : str.toLowerCase()
}

const OrderId = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}

const SettingsTitle = cell => {
  return cell ? cell.value : ""
}

const SettingsValue = cell => {
  return cell.value ? cell.value : ""
}

const Companyname = cell => {
  return cell.value ? cell.value : ""
}

const Employeename = cell => {
  return cell.value ? cell.value : ""
}

export { OrderId, SettingsTitle, SettingsValue,Companyname,Employeename }
